var map = {
	"./en/btn_Synthesis_2.png": "farf",
	"./es/btn_Synthesis_2.png": "+/9M",
	"./pt/btn_Synthesis_2.png": "dG5G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r8Ua";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_Synthesis_2\.png$
// module id = r8Ua
// module chunks = 0